import Component from "@glimmer/component"

export default class GoogleClassroomAddGCPostMenuComponent extends Component {}
